export var Checkbox = {
    baseStyle: {},
    sizes: {},
    variants: {},
    defaultProps: {
        size: 'md',
    },
};
